import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function useMatomoPageViewTracker() {
	const history = useHistory();

	useEffect(() => {
		const unregister = history.listen((location) => {
			const enterpriseId = localStorage.getItem("enterprise_id");
			const email = localStorage.getItem("email");

			console.log("enterpriseId", enterpriseId);
			console.log("email", email);

			if (enterpriseId && email) {
				const userID = `enterpriseId:${enterpriseId}/email:${email}`;
				console.log("Matomo Tracking", userID);

				window._paq.push(["setUserId", userID]);
				window._paq.push(["setCustomUrl", location.pathname]);
				window._paq.push(["trackPageView"]);
			}
		});

		return () => {
			unregister();
		};
	}, [history]);
}
